/* eslint-disable react/jsx-pascal-case */
import {
  CmpSelectBox,
  CmpButton,
  CmpDatePicker,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import {
  Set_SliceCyclecount_SummaryObj,
  Set_SliceCyclecount_HeadObj,
} from "./SliceCyclecount";
import { Summary_Grid_Columns } from "./CyclecountAction";
import moment from "moment";
import { fAlertToast, GetGitterColumns } from "../../Utility/Utilitys";
import Cyclecount_BreadCrumbs from "./Cyclecount_BreadCrumbs";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CyclecountSummaryTblCard } from "./processComponent/CyclecountSummaryTblCard";
import GCSummaryModal from "../../Component/Common/ReuseableComponent/GCSummaryModal";
import { CycleCount_summary_API } from "../../Server/ApiV2";

export default function Cyclecount() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const LocationFocusOnLoad = useRef(null);
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const [sSummaryGridRow, setSummaryGridRow] = useState([]);
  // modal start

  const [showModal, setShowModal] = useState(false);

  // modal end

  const [sSummaryObj, setSummaryObj] = useState({
    loc: vRdxuserLoc[0]?.UID,
    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
  });
  const fSummary_OnChange = (e) => {
    setSummaryObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fLoad = (e) => {
    dispatch(
      Set_SliceCyclecount_SummaryObj({
        sSummaryObj,
      })
    );
    Get_Load_Grid_Data();
    setShowModal(false);
  };
  const Get_Load_Grid_Data = async () => {
    var vSummaryObj = {
      Loc: sSummaryObj.loc === "" ? vRdxuserLoc[0]?.UID : sSummaryObj?.loc,
      Date1: moment(sSummaryObj?.dateFrom).format("YYYY/MM/DD"),
      Date2: moment(sSummaryObj?.dateTo).format("YYYY/MM/DD"),
      UserCd: vRdxuserInfo.UserID,
    };
    const Resp = await CycleCount_summary_API(vSummaryObj);

    if (Resp?.status === 200) {
      if (Resp?.data?.ResultSet?.length > 0) {

        setSummaryGridRow(Resp?.data?.ResultSet);
      } else {
        setSummaryGridRow([]);
      }
    }

  }

  const fRowCLick = (item) => {
    dispatch(
      Set_SliceCyclecount_HeadObj({
        SheetNo: item.row.A_SheetId,
        Loc: item.row.A_Loc,
        LocName: item.row.LocName,
        Date: item.row.A_Date,
        ReferenceNo: item.row.A_RefNo,
        A_DocStat: item.row.A_Status,
        BinCd: item.row.BinCd || "",
        BinName: item.row.BinName || ""
      })
    );
    navigate("/cyclecountDetail");
  };

  const fNew = () => {
    dispatch(
      Set_SliceCyclecount_HeadObj({
        SheetNo: 0,
        Loc: vRdxuserLoc[0]?.UID,
        LocName: vRdxuserLoc[0]?.Name1,
        Date: new Date(),
        ReferenceNo: "",
        A_DocStat: "ENTER",
        BinCd: "",
        BinName: ""
      })
    );
    navigate("/cyclecountDetail");
  }



  useEffect(() => {
    Get_Load_Grid_Data();
  }, []);

  useEffect(() => {
    LocationFocusOnLoad?.current?.focus();
  }, []);
  return (
    <div className="container-fluid my-3">
      <div className="Breadcrumbs d-flex justify-content-between align-items-center">
        <div >
          <Cyclecount_BreadCrumbs />
        </div>
        <div className="d-flex">
          <div className="pe-3">
            <CmpButton
              xbtnName="New"
              xOnClick={() => {
                fNew()
              }}
              xVariant="contained"
              xSize="small"
            />
          </div>
          <div>
            <CmpButton
              xbtnName="Filter"
              xOnClick={() => {
                setShowModal(true);
              }}
              xVariant="contained"
              xSize="small"
            />
          </div>

        </div>
      </div>
      <div className="Instant-picking-head">
        <Grid
          container
          spacing={{ xs: 2, sm: 2, md: 2 }}
          className="align-items-center"
          style={{ display: "none" }}
        >
          <Grid item lg={2} md={4} xs={6}>
            <CmpSelectBox
              xref={LocationFocusOnLoad}
              xLabelText="Location"
              xValue={sSummaryObj.loc}
              xOnChange={(event) => fSummary_OnChange(event)}
              xName={"loc"}
              xData={vRdxuserLoc}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"From"}
              xValue={sSummaryObj.dateFrom}
              xOnChange={(newValue) => {
                setSummaryObj((obj) => ({
                  ...obj,
                  dateFrom: newValue.$d,
                }));
              }}
              xName={"dateFrom"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={12} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"To"}
              xValue={sSummaryObj.dateTo}
              xOnChange={(newValue) =>
                setSummaryObj((obj) => ({ ...obj, dateTo: newValue.$d }))
              }
              xName={"dateTo"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>

          <Grid item lg={2} md={4} xs={6} className="bintransfet-data-load-btn">
            <CmpButton
              xbtnName="Load"
              xOnClick={fLoad}
              xVariant="contained"
              xSize="small"
            />
          </Grid>


        </Grid>
        <>
          <Box
            sx={{ height: vMediaQuery ? "50vh" : "70vh", width: "100%" }}
            className="bin-transfer-data"
          >

            <CyclecountSummaryTblCard data={sSummaryGridRow} onClick={fRowCLick} />
          </Box>
        </>
      </div>
      <GCSummaryModal
        xOpen={showModal}
        fCloseModal={() => {
          setShowModal(false);
        }}
        xTitle="Filter"
        component={
          <>
            <Grid
              container
              spacing={2}
              className="align-items-center"
            >
              <Grid item xs={12} >
                <CmpSelectBox
                  xref={LocationFocusOnLoad}
                  xLabelText="Location"
                  xValue={sSummaryObj.loc}
                  xOnChange={(event) => fSummary_OnChange(event)}
                  xName={"loc"}
                  xData={vRdxuserLoc}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={12} className="bintransfer-data-date">
                <CmpDatePicker
                  xLabelText={"From"}
                  xValue={sSummaryObj.dateFrom}
                  xOnChange={(newValue) => {
                    setSummaryObj((obj) => ({
                      ...obj,
                      dateFrom: newValue.$d,
                    }));
                  }}
                  xName={"dateFrom"}
                  xError={false}
                  xErrorMessage={false}
                    xFullWidth={true}
                />
              </Grid>
              <Grid item xs={12} className="bintransfer-data-date">
                <CmpDatePicker
                  xLabelText={"To"}
                  xValue={sSummaryObj.dateTo}
                  xOnChange={(newValue) =>
                    setSummaryObj((obj) => ({ ...obj, dateTo: newValue.$d }))
                  }
                  xName={"dateTo"}
                  xError={false}
                  xErrorMessage={false}
                    xFullWidth={true}
                />
              </Grid>

              <Grid item xs={12} className="bintransfet-data-load-btn text-center">
                <CmpButton
                  xbtnName="Load"
                  xOnClick={fLoad}
                  xVariant="contained"
                  xSize="small"
                />
              </Grid>


            </Grid>
          </>
        }
      />
    </div>
  );
}
